const data = {
	title: "Eksport/Import",
	export_title: "Eksport",
	import_title: "Import",
	exportimport_title: "Eksport/Import",
	select_module: "Velg data type",
	view_data: "Vis data",
	download_import_template: "Last ned mal",
	select_import_template: "Velg import mal",
	import_file: "Importer data",
	import_success: "Vellykket import",
	invalid_file: "Feil mal brukt",
	import_failed: "Data import feilet",
	student_to_groups: "Elever til elvegrupper",
};
export default data;